/**
 * Main Entry Point - Auth.HireItNow.com
 *
 * This is the entry point for the React application.
 * It renders the root App component into the DOM.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

// Get the root element from the HTML
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error(
    'Failed to find root element. ' +
      'Make sure there is a <div id="root"></div> in your index.html'
  );
}

// Create the React root and render the app
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
